@import "tailwindcss";

html, body, #root {
  margin: 0;
  padding: 0;
  background: #F4ECDB;
  font-family: 'DM Sans', system-ui, sans-serif;
  color: #221912;
  -webkit-font-smoothing: antialiased;
  height: 100%;
}

* { box-sizing: border-box; }

/* iOS Safari auto-zooms when focusing a form control whose font-size is < 16px,
   and never zooms back out on blur. Our inputs render at 14px (mono 13, combobox
   12) via inline styles, so force 16px on touch devices only — desktop keeps its
   editorial sizing, and the !important is required to beat the inline fontSize. */
@media (pointer: coarse) {
  input:not([type="checkbox"]):not([type="radio"]),
  textarea,
  select {
    font-size: 16px !important;
  }
}

::-webkit-scrollbar { width: 8px; height: 8px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 999px; }

.mila-md > :first-child { margin-top: 0; }
.mila-md > :last-child { margin-bottom: 0; }
.mila-md p { margin: 0 0 8px; }
.mila-md ul, .mila-md ol { margin: 4px 0 8px; padding-left: 20px; }
.mila-md li { margin: 2px 0; }
.mila-md li > p { margin: 0; }
.mila-md h1, .mila-md h2, .mila-md h3, .mila-md h4 {
  font-family: 'Newsreader', Georgia, serif;
  font-weight: 500;
  margin: 10px 0 4px;
  line-height: 1.25;
}
.mila-md h1 { font-size: 17px; }
.mila-md h2 { font-size: 16px; }
.mila-md h3, .mila-md h4 { font-size: 15px; }
.mila-md strong { font-weight: 600; }
.mila-md code {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.9em;
  background: rgba(0,0,0,0.05);
  padding: 1px 4px;
  border-radius: 4px;
}
.mila-md pre {
  margin: 6px 0;
  padding: 8px 10px;
  background: rgba(0,0,0,0.05);
  border-radius: 6px;
  overflow-x: auto;
  font-size: 12px;
}
.mila-md pre code { background: transparent; padding: 0; }
.mila-md a { color: #B8552F; text-decoration: underline; }
.mila-md blockquote {
  margin: 6px 0;
  padding-left: 10px;
  border-left: 2px solid rgba(0,0,0,0.15);
  color: #5a4c3e;
}
